// extracted by mini-css-extract-plugin
export default {"button":"RoundedButton_button__11MSJ","uploadBtn":"RoundedButton_uploadBtn__91gmc","disableMsg":"RoundedButton_disableMsg__Dukfe"};